





import {
  defineComponent,
} from '@vue/composition-api';

import CommonFormWithMaterialEditor from '@/components/Store/CommonFormWithMaterialEditor.vue';

const Edit = defineComponent({
  components: {
    CommonFormWithMaterialEditor,
  },
  // setup() {},
});

export default Edit;
